if (!customElements.get('zs-cart-carousel')) {
  customElements.define('zs-cart-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.zs-cart-journey__cards');
      this.controls = this.querySelector('.zs-cart-journey__arrows');
      if (!this.track || !this.controls) return;
      this.buttons = Array.from(this.controls.querySelectorAll('button'));
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = this.track.scrollLeft < 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
      };
      this.handleClick = (event) => {
        const button = event.target.closest('button[data-step]');
        if (!button || button.disabled) return;
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({
          left: Number(button.dataset.step) * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.controls.addEventListener('click', this.handleClick);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.controls?.removeEventListener('click', this.handleClick);
      this.track?.removeEventListener('scroll', this.update);
    }
  });
}
